/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Instagram_Review_Cies_Location_AltInputs */

const es_landing_instagram_review_cies_location_alt = /** @type {(inputs: Landing_Instagram_Review_Cies_Location_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historia de Instagram de carla_dipinto navegando a las Islas Cíes con Zarpar`)
};

const gl_landing_instagram_review_cies_location_alt = /** @type {(inputs: Landing_Instagram_Review_Cies_Location_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historia de Instagram de carla_dipinto navegando ás Illas Cíes con Zarpar`)
};

const en_landing_instagram_review_cies_location_alt = /** @type {(inputs: Landing_Instagram_Review_Cies_Location_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram story by carla_dipinto sailing to the Cíes Islands with Zarpar`)
};

/**
* | output |
* | --- |
* | "Instagram story by carla_dipinto sailing to the Cíes Islands with Zarpar" |
*
* @param {Landing_Instagram_Review_Cies_Location_AltInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_instagram_review_cies_location_alt = /** @type {((inputs?: Landing_Instagram_Review_Cies_Location_AltInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Instagram_Review_Cies_Location_AltInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_instagram_review_cies_location_alt(inputs)
	if (locale === "en") return en_landing_instagram_review_cies_location_alt(inputs)
	return es_landing_instagram_review_cies_location_alt(inputs)
});